itsoftApp.createModule("animateScroll", ["windowResize", "startLoad"], function () {
    const module = this;
    let pageHeader = document.querySelector("[data-fixed='true']");
    let viewportSize = itsoftApp.commonVars.viewWidth;
    let headerHeight = itsoftApp.commonVars.headerHeight;
    // переменные для подсвечивания ссылок по скролу на странице инструкции
    let header = document.querySelector('header');
    let menu = document.querySelector('.side-instruction__links');
    let linksForBlock = document.querySelectorAll('.js-link-for-block');
    let trackbarLine = document.querySelector('.js-trackbar-line');
    let trackbarContent = document.querySelector('.js-trackbar-content');
    let trackbarOffset;
    let trackbarContentHeight;
    let trackbarLineWidth;
    let currentLink;
    let oldCurrentLink;
    let blocks = [];
    let blockName;
    let blockNameCur;
    let blockItem;
    let blockHeight;
    let blockOffset;
    let layer;
    let rect;
    let scrollTop;
    // переменные для подсвечивания ссылок по скролу на странице инструкции

    const libraries = {
        smoothScroll: {
            name: "smoothScroll",
            queue: [],
            started: false,
            loaded: false,
            script: "/assets/scripts/smoothScroll/smooth-scroll.min.js"
        }
    }

    const ResponsiveScroll = function ({target, targetTrigger, clickedScrollFlag, settings}) {
        this.exemplar = "";
        this.targetTrigger = targetTrigger;
        this.target = target;
        this.settings = settings;
        this.clickedScrollFlag = clickedScrollFlag;
        this.defaultPadding = 0;
        this.maxMobileWidth = 767;
        this.speed = 300;
        this.init();
    }

    ResponsiveScroll.prototype.startScroll = function () {
        const RESPONSIVE_SCROLL = this;

        if (pageHeader) {
            if (this.target.hasAttribute("data-offset")) {
                if (viewportSize <= this.maxMobileWidth) {
                    this.defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
                } else {
                    this.defaultPadding = itsoftApp.commonVars.headerHeight + itsoftApp.commonVars.headerHeight / 2;
                }
            } else if (this.target.hasAttribute("data-offset-mobile") && viewportSize <= this.maxMobileWidth) {
                this.defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
            } else if (window.innerWidth < 1024 && menu) {
                this.defaultPadding = itsoftApp.commonVars.headerHeight + menu.clientHeight;
            } else {
                this.defaultPadding = itsoftApp.commonVars.headerHeight;
            }
        }

          /* добавляем отступ сверху, если, например, есть фиксированная шапка */
        this.settings = {
            offset: this.defaultPadding
        };

        /* вычисляем скорость и время, за которое произойдёт прокрутка */

        if (this.speed) {
            this.settings.speed = this.speed;
        }

        this.settings.durationMin = 500;

        if (this.speedAsDuration) {
            this.settings.speedAsDuration = this.speedAsDuration;
        }

        this.settings.customEasing = function (time) {
            return -(Math.cos(Math.PI * time) - 1) / 2;
        };

          /* Уничтожаем предыдущий экземпляр, если он есть */
        if (this.exemplar) {
            this.exemplar.cancelScroll();
            this.exemplar.destroy();
            this.exemplar = "";
        }
          
        this.exemplar = new SmoothScroll();

        if (!document.body.classList.contains("is-popup-opened")) {
            this.exemplar.animateScroll(this.target, "auto", this.settings);
        } else {
            setTimeout(function () {
                RESPONSIVE_SCROLL.exemplar.animateScroll(this.target, "auto", this.settings);
            }, 800);
        }
    }

    ResponsiveScroll.prototype.init = function () {
        const RESPONSIVE_SCROLL = this;

        new itsoftApp.modules.startLoad.callback(function () {
            if (!RESPONSIVE_SCROLL.clickedScrollFlag) {
                RESPONSIVE_SCROLL.startScroll();
            } else {
                RESPONSIVE_SCROLL.targetTrigger.addEventListener("click", function (evt) {
                    evt.preventDefault();
                    let scrollId = evt.currentTarget.href;
                  
                    if (!scrollId || !(scrollId = scrollId.split("#")[1])) {
                        return;
                    }

                    /* Находим элемент, до которого нужно прокрутить страницу, и передаём его в функцию */
                    RESPONSIVE_SCROLL.target = document.querySelector("#" + scrollId);
                    RESPONSIVE_SCROLL.startScroll();
                });
            }
        }, libraries.smoothScroll);

        return true;
    }

    // подсвечивание ссылок по скролу
    function getElementOffset(el) {
        rect = el.getBoundingClientRect();
        scrollTop = window.scrollY;
        return rect.top + scrollTop;
    }

    function getTrackbarPercent() {
        return Math.round((scrollY + layer - trackbarOffset) / (trackbarContentHeight * 0.01));
    }

    function getTabletSize() {
        return window.innerWidth < 1024;
    }

    function updTrackbar() {
        trackbarOffset = getElementOffset(trackbarContent);
        trackbarContentHeight = trackbarContent.clientHeight;
        if (((scrollY + layer) >= trackbarOffset) &&
            (scrollY + layer) < (trackbarOffset + trackbarContentHeight)) {
                trackbarLineWidth = getTrackbarPercent();
                trackbarLine.style.width = trackbarLineWidth <= 100 ? trackbarLineWidth + '%' : '100%';
            }
        else {
            trackbarLine.style.width = '0%';
        }
    }

    function setLinkForBlock() {
        oldCurrentLink = document.querySelector('.js-link-for-block._active');
        
        if (oldCurrentLink) {
            oldCurrentLink.classList.remove('_active');
        }

        layer = header.clientHeight;
        if (window.innerWidth < 1024) {
            layer += menu.clientHeight;
        }

        for (let i = 0; i < blocks.length; i++) {
            blockNameCur = blocks[i];
            blockItem = document.querySelector('#' + blockNameCur);
            blockOffset = getElementOffset(blockItem);
            blockHeight = blockItem.clientHeight;
            if (((scrollY + layer + 1) >= blockOffset) &&
                (scrollY + layer) < (blockOffset + blockHeight - 1)) {
                    currentLink = document.querySelector('.js-link-for-block[href="#' + blockNameCur + '"]');
                    currentLink.classList.add('_active');
                }
        }
        // Горизонтальный скролл ссылок в меню
        if (currentLink) {
            menu.scrollLeft = currentLink.closest('li').offsetLeft - 10;
        }

        // Полоса заполнения скролла на деталке статьи
        if ((trackbarLine && trackbarContent) && !getTabletSize()) {
            updTrackbar();
        }
    }

    if (linksForBlock.length > 0) {
        for (let i = 0; i < linksForBlock.length; i++) {
            var el = linksForBlock[i];
            blockName = el.getAttribute('href').replace('#', '');
            if (blockName != '' && !~blocks.indexOf(blockName)) {
                blocks.push(blockName);
            }
        }

        window.addEventListener('scroll', setLinkForBlock);
        window.addEventListener('resize', setLinkForBlock);
    };
    // подсвечивание ссылок по скролу


    const links = document.querySelectorAll("a[href^='#']:not([href='#'])");

    /* Проходимся по всем элементам, у которых в href есть хэш */
    Array.prototype.forEach.call(links, function (targetTrigger) {
        const clickedScrollFlag = true;
        var newScroll = new ResponsiveScroll({targetTrigger, clickedScrollFlag});
    });

    const hash = location.hash;
    const hashElement = hash ? document.querySelector(hash) : null;

    itsoftApp.modules.pageLoad.addEvent(function () {
        setTimeout(function () {
            if (hash && hashElement) {
                const target = hashElement;
                new ResponsiveScroll({target});
            }
        }, 500)
    });

    module.callback = ResponsiveScroll;

    return module;
});